<template>
  <b-container>
    <WizardPageTitle title="Deployment and CI/CD" />
    <b-row>
      <b-col>
        <b-form>
          <b-form-group description="Include Dockerfile in the project">
            <b-form-checkbox v-model="docker">
              Enable Docker support
            </b-form-checkbox>
          </b-form-group>
          <b-form-group description="Include Procfile in the project">
            <b-form-checkbox v-model="heroku">
              Enable Heroku support
            </b-form-checkbox>
          </b-form-group>
          <b-form-group description="Set up background tasks using `bull` queue, backed by Redis">
            <b-form-checkbox v-model="use_bull">
              Bull queue support
            </b-form-checkbox>
          </b-form-group>
          <h3
            class="pt-2 border-bottom"
          >
            Code Options
          </h3>
          <b-form-group description="Use `prettier` to automatically format your code">
            <b-form-checkbox v-model="use_prettier">
              Use prettier
            </b-form-checkbox>
          </b-form-group>
        </b-form>
      </b-col>
    </b-row>
    <WizardPrevNext />
  </b-container>
</template>

<script>
import WizardPageTitle from './widgets/WizardPageTitle.vue';
import WizardPrevNext from './widgets/WizardPrevNext.vue';
import navigationMixin from './mixins/navigation';

export default {
  name: 'DevOps',
  components: {
    WizardPageTitle,
    WizardPrevNext,
  },
  mixins: [navigationMixin],
  data() {
    return {
      docker: !!this.$store.state.recipe.docker,
      heroku: !!this.$store.state.recipe.heroku,
      use_prettier: !!this.$store.state.recipe.use_prettier,
      use_bull: !!this.$store.state.recipe.use_bull,
    };
  },
  methods: {
    commit() {
      this.$store.commit('updateRecipe', {
        docker: this.docker,
        heroku: this.heroku,
        use_prettier: this.use_prettier,
        use_bull: this.use_bull,
      });
      return true;
    },
  },
};
</script>
